var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 22a7 7 0 0 1-7-7V7a7 7 0 0 1 14 0v8a7 7 0 0 1-7 7m0-20a5 5 0 0 0-5 5v8a5 5 0 0 0 10 0V7a5 5 0 0 0-5-5M0 16c0 4.694 3.957 8.506 9 8.956V26H5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-1.044c5.043-.45 9-4.262 9-8.956v-4a1 1 0 1 0-2 0v4c0 3.86-3.59 7-8 7s-8-3.14-8-7v-4a1 1 0 1 0-2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgMicrophone;